import React, { useState } from 'react';

import CenteredCircularProgress from '../../../../../../../../../../../lib/designSystem/CircularProgress';
import ShoppingCartFactoringRejected from './components/0.1_ShoppingCartRejected';
import ShoppingCartFactoringValidating from './components/0.5_ShoppingCartInValidating';
import ShoppingCartCreditLineMissingInfo from './components/0.7_ShoppingCartInMissingInfo';
import ShoppingCartFactoringNotRequested from './components/0_ShoppingCartNotRequested';
import ShoppingCartFactoringInReview from './components/1_ShoppingCartInReview';
import ShoppingCartFactoringReviewed from './components/2_ShoppingCartReviewed';
import ShoppingCartFactoringAssigned from './components/3_ShoppingCartAssigned';
import ShoppingCartFactoringAlive from './components/4_ShoppingCartActive';

export interface FactoringRequest {
  id: number;
  status: string;
  sender: string;
  recipient: string;
  validUntil: Date;
  paymentDate: Date;
  amount: number;
  extraData: boolean;
  relation?: any;
  businessId: number;
}

const Summary = (props: any) => {
  const {
    shoppingCartType,
    openShoppingCart,
    setOpenShoppingCart,
    openRequest,
    setUp,
    handleDetails,
  } = props;
  const [loading, setLoading] = useState(false);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      {loading ? <CenteredCircularProgress type="dialog" /> : <div></div>}
      {shoppingCartType === 'No solicitada' && (
        <ShoppingCartFactoringNotRequested
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          setUp={setUp}
          setLoading={setLoading}
        />
      )}
      {shoppingCartType === 'Validando' && (
        <ShoppingCartFactoringValidating
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          setUp={setUp}
          setLoading={setLoading}
        />
      )}
      {shoppingCartType === 'Rechazada' && (
        <ShoppingCartFactoringRejected
          setOpenShoppingCart={setOpenShoppingCart}
          openShoppingCart={openShoppingCart}
          openRequest={openRequest}
          setUp={setUp}
          setLoading={setLoading}
          handleDetails={handleDetails}
        />
      )}
      {shoppingCartType === 'Faltan datos' && (
        <ShoppingCartCreditLineMissingInfo
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          setUp={setUp}
          setLoading={setLoading}
        />
      )}
      {shoppingCartType === 'En revisión' && (
        <ShoppingCartFactoringInReview
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
        />
      )}
      {shoppingCartType === 'Revisada' && (
        <ShoppingCartFactoringReviewed
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          updateStatus
          setUp={setUp}
          handleDetails={handleDetails}
          setLoading={setLoading}
        />
      )}
      {shoppingCartType === 'Asignada' && (
        <ShoppingCartFactoringAssigned
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          handleDetails={handleDetails}
          setUp={setUp}
          setLoading={setLoading}
        />
      )}
      {(shoppingCartType === 'Activa' ||
        shoppingCartType === 'Congelada' ||
        shoppingCartType === 'Vencida') && (
        <ShoppingCartFactoringAlive
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          openRequest={openRequest}
          handleDetails={handleDetails}
          setUp={setUp}
          setLoading={setLoading}
        />
      )}
    </div>
  );
};

export default Summary;
